import { Button, Col, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table/interface";
import { useEffect, useState } from "react";
import { AuditLogApi } from "../../../../../apis/audit.api";
import { LogType } from "../../../../../constants/app.enums";
import { AuditLog, YearFilter } from "../../../../../models/audit-log";
import showNotification from "../../../../common/notification";
import PaginationComponent from "../../../../common/pagination/component/pagination";
import LogComponent from "../audit-log-component/log-component";
import DrawerFilter from "../drawer-filter/drawer-filter";
import "./system-log.scss";

export function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  return `${month}/${date}/${year}`;
}

const yearList: YearFilter[] = [
  { id: 1, label: "2024", value: "" },
];

function YearFilterList(props: { filters: YearFilter[] }) {
  return (
    <>
      {props.filters.map((button) => (
        <span key={button.id}>
          <Button value={button.value}>{button.label}</Button>
        </span>
      ))}
    </>
  );
}


function SystemLog() {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [filterData, setFilterData] = useState<any>({});

  useEffect(() => {
    handleGetAuditLogs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, pageSize, pageNumber]);

  const columns: ColumnsType<AuditLog> = [
    {
      title: null,
      key: 1,
      render: (record: any) => {
        return <LogComponent type={LogType.SystemLog} log={record} />;
      },
    },
  ];

  const handleGetAuditLogs = async () => {
    try {
      setOpenDrawer(false);
      setIsLoading(true);

      let filterObject = {
        startDate: filterData.dateTimeFilter ? filterData.dateTimeFilter[0].toISOString() : null,
        endDate: filterData.dateTimeFilter ? filterData.dateTimeFilter[1].toISOString() : null,
        loginName: filterData.loginNameFilter ?? null,
        ipRequest: filterData.ipFilter ?? null,
        logStatus: filterData.statusFilter ??  null
      };
  
      const res = await AuditLogApi.getAuditLogs(pageNumber, pageSize, LogType.SystemLog, filterObject);
      
      setLogs(res?.data?.records ?? []);
      setTotalRecords(res?.data?.totalRecords ?? 0);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportOperationLog = () => {
    showNotification(
      "error",
      "This feature is not implement for Transaction Log yet."
    );
  };

  return (
    <>
      <div className="row-filter">
        <span className="year-filter">
          <YearFilterList filters={yearList} />
        </span>
        <span className="right-filter">
        <i className="icon-paper-export" onClick={handleExportOperationLog}></i>
        <i className="icon-filter-3" onClick={() => setOpenDrawer(true)}></i>
        <DrawerFilter
          openDrawer={openDrawer}
          onClose={() => setOpenDrawer(false)}
          filterData={filterData}
          handleFilterData={(data) => setFilterData(data)}
          type={LogType.OperationLog}
          setPageNumber={(data) => setPageNumber(data)}
        />
        </span>
      </div>
      <Row>
        <Col span={24}>
          <Table
            showHeader={false}
            rowKey={(x) => x.traceId}
            columns={columns}
            dataSource={logs}
            loading={isLoading}
            className="tab-audlt-log"
            pagination={{
              pageSize: pageSize,
              current: pageNumber,
              style: { display: "none" },
            }}
          />
        </Col>
        <PaginationComponent
          totalRecords={totalRecords}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      </Row>
    </>
  );
}

export default SystemLog;
